class ThinGap {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		const number = parseFloat(el.textContent.replace(/\s+/g, ''));

		const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');

		el.textContent = `${formattedNumber}\u2009₽`;
	}
}

document.querySelectorAll('[data-thin-gap]').forEach((el) => new ThinGap(el));

export default ThinGap;
